const hexadecimalBase: number = 16
export function newGuid() {
  // tslint:disable-next-line:only-arrow-functions
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    // tslint:disable-next-line:one-variable-per-declaration no-bitwise triple-equals no-magic-numbers
    const r = Math.random() * hexadecimalBase | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(hexadecimalBase)
  })
}
